(function($) {
    $(document).ready(function() {
        $.slidebars();
    });
}) (jQuery);
$(window).bind('resize load', function() {
    if ($(this).width() < 992) {
        $('.sidebar .collapse').removeClass('in');
        $('.sidebar .collapse').addClass('out');
    } else {
        $('.sidebar .collapse').removeClass('out');
        $('.sidebar .collapse').addClass('in');
    }
});
$(window).bind('resize load', function() {
    if ($(this).width() < 992) {
        $('.staff .collapse').removeClass('in');
        $('.staff .collapse').addClass('out');
    } else {
        $('.staff .collapse').removeClass('out');
        $('.staff .collapse').addClass('in');
    }
});

$('.panel-heading').on("click", function (event) {
     $(this).toggleClass('rotate');
     $(this).toggleClass('rotate2');
});
// $('.menu .panel-heading:first-child').on("click", function (event) {
//      $(this).toggleClass('rotate');
//      $(this).toggleClass('rotate2');
// });
// $('.meals .panel-heading').on("click", function (event) {
//      $(this).toggleClass('rotate');
//      $(this).toggleClass('rotate2');
// });

$('.add-to-cart').click(function(){
    var $this = $(this);
    //change background color via CSS class
    $this.addClass('added');
    // set a timeout that will revert back class after 5 seconds:
    window.setTimeout(function() {
        $this.removeClass('added');
    }, 2 * 1000);
});


$(document).ready(function() {
    if($(window).width() < 992) {
        $('.readmore').readmore({speed: 500});
    }
  
  $(".product .minus button, .quick-add-to-cart .minus button").on("click", function(e) {
    	e.preventDefault();

        var $button = jQuery(this);
        var oldValue = $button.parent().parent().find("input").val();

            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }

        $button.parent().parent().find("input").val(newVal);

    });
  $(".product .plus button, .quick-add-to-cart .plus button").on("click", function(e) {
		e.preventDefault();
        var $button = jQuery(this);
        var oldValue = $button.parent().parent().find("input").val();
        var newVal = parseFloat(oldValue) + 1;
        $button.parent().parent().find("input").val(newVal);

    });

  
  
  
  
});


